module.exports = __webpack_public_path__ + "static/images/share_icon.416d73a.jpg";